module.exports = __webpack_public_path__ + "static/img/318_TO8_2480.5e3fe8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/318_TO8_2480.jpg
// module id = i8gn
// module chunks = 0